import React, { useEffect, useState } from "react";
import { BiGitBranch } from "react-icons/bi";
import { IoCloseSharp } from "react-icons/io5";
import { Button, Col, Modal, ModalBody, Row } from "reactstrap";
import FormInput from "../formInput/FormInput";
import { Select } from "antd";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
const AddSubCategory = ({
  modal,
  toggle,
  onClose,
  type = "add",
  onSubmit,
  selectedSubCategory,
  setSelectedSubCategory,
}) => {
  const { all_categories, all_subCategories } = useSelector(
    (state) => state.redux
  );
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    subCategoryName: "",
    categoryId: "",
    subCategoryImageURL: "",
    subCategoryImage: null,
  });
  const handleSubmitSubCategory = () => {
    if (!data.subCategoryName || !data.categoryId) {
      toast.error("Form data incomplete");
      return;
    }
    onSubmit(
      data,
      () => {
        setData({
          subCategoryName: "",
          categoryId: "",
          subCategoryImage: null,
          subCategoryImageURL: "",
        });
      },
      setLoading
    );
  };
  useEffect(() => {
    if (selectedSubCategory && type === "edit") {
      setData({
        subCategoryName: selectedSubCategory?.subCategoryName ?? "",
        categoryId: selectedSubCategory?.categoryId ?? "",
        subCategoryImage: selectedSubCategory?.subCategoryImage ?? null,
        subCategoryImageURL: selectedSubCategory?.subCategoryImageURL ?? null,
      });
    }
  }, [selectedSubCategory, type]);
  useEffect(() => {
    const cat = all_categories?.map((i) => ({
      value: i?._id,
      label: i?.categoryName,
    }));
    setCategories(cat || []);
  }, [all_categories]);
  return (
    <Modal isOpen={modal} toggle={toggle} centered size="md" onClosed={onClose}>
      <ModalBody className="p-0 border-0">
        <div className="modern-modal-header d-flex justify-content-between align-items-center p-4 border-bottom bg-light rounded-top">
          <h5 className="fw-bold text-dark mb-0 d-flex align-items-center gap-2">
            <BiGitBranch className="text-primary" size={20} /> {type === "edit" ? "Edit" : "Add"} Sub Category
          </h5>
          <IoCloseSharp
            size={24}
            className="text-muted pointer hover-opacity-75"
            onClick={onClose}
            style={{ cursor: "pointer" }}
          />
        </div>
        <Row className="mb-0 p-4">
          <Col md={12}>
            <FormInput
              type="text"
              label="Sub Category"
              placeholder="Sub Category Name..."
              size="large"
              value={data.subCategoryName}
              handleChange={(e) =>
                setData({ ...data, subCategoryName: e.target.value })
              }
            />
          </Col>
          <Col md={12} className="mb-3">
            <label className="fw-bold mb-1">Select Category</label>
            <Select
              showSearch
              style={{ width: "100%" }}
              placeholder="Search to Select"
              optionFilterProp="label"
              size="large"
              options={categories}
              value={data.categoryId || undefined}
              onChange={(value) => setData({ ...data, categoryId: value })}
            />
          </Col>
          <Col md={12} className="mb-3">
            {data?.subCategoryImageURL && (
              <div className="position-relative d-inline-block me-2 mb-2">
                <span
                  onClick={() => setData({ ...data, subCategoryImageURL: "" })}
                  style={{
                    position: "absolute",
                    top: "-8px",
                    right: "-8px",
                    borderRadius: "50%",
                    cursor: "pointer",
                    padding: "2px",
                    zIndex: 1,
                  }}
                >
                  <IoCloseSharp
                    size={18}
                    color="red"
                    className="bg-danger text-white rounded-pill"
                  />
                </span>
                <img
                  className="rounded-3 border border-1"
                  height={50}
                  width={50}
                  src={data?.subCategoryImageURL}
                  alt="SubCategoryURL"
                />
              </div>
            )}
            <div>
              <FormInput
                type="text"
                label="Sub Category Image"
                placeholder={"Image URL"}
                size="large"
                value={data.subCategoryImageURL}
                handleChange={(e) =>
                  setData({ ...data, subCategoryImageURL: e.target.value })
                }
              />
            </div>
          </Col>
          <Col md={12}>
            {data?.subCategoryImage && (
              <div className="position-relative d-inline-block me-2 mb-2">
                <span
                  onClick={() => setData({ ...data, subCategoryImage: null })}
                  style={{
                    position: "absolute",
                    top: "-8px",
                    right: "-8px",
                    borderRadius: "50%",
                    cursor: "pointer",
                    padding: "2px",
                    zIndex: 1,
                  }}
                >
                  <IoCloseSharp
                    size={18}
                    color="red"
                    className="bg-danger text-white rounded-pill"
                  />
                </span>
                <img
                  className="rounded-3 border border-1"
                  height={50}
                  width={50}
                  src={
                    typeof data?.subCategoryImage === "object"
                      ? URL.createObjectURL(data?.subCategoryImage)
                      : data?.subCategoryImage
                  }
                  alt="SubCategoryFile"
                />
              </div>
            )}
            <FormInput
              type="file"
              label="Sub Category Image (optional)"
              size="large"
              handleChange={(e) =>
                setData({ ...data, subCategoryImage: e.target.files[0] })
              }
            />
          </Col>
          <div className="d-flex justify-content-between align-items-center mt-3">
            <div className="text-muted" style={{ fontSize: "0.8rem" }}>
              {selectedSubCategory?.createdBy?.username && (
                <div>
                  <span className="fw-semibold">Created by:</span> {selectedSubCategory.createdBy.username}
                  {selectedSubCategory.createdAt && ` on ${new Date(selectedSubCategory.createdAt).toLocaleString()}`}
                </div>
              )}
              {selectedSubCategory?.updatedBy?.username && (
                <div>
                  <span className="fw-semibold">Last updated by:</span> {selectedSubCategory.updatedBy.username}
                  {selectedSubCategory.updatedAt && ` on ${new Date(selectedSubCategory.updatedAt).toLocaleString()}`}
                </div>
              )}
            </div>
            <div className="d-flex gap-2">
              <Button
                className="bg-white text-black border border-1 mx-2"
                onClick={onClose}
                size="sm"
              >
                Cancel
              </Button>
              <Button
                className="bg-primary-color border-none text-white"
                onClick={handleSubmitSubCategory}
                size="sm"
                disabled={loading}
              >
                {loading ? "Saving..." : "Save"}
              </Button>
            </div>
          </div>
        </Row>
      </ModalBody>
    </Modal>
  );
};
export default AddSubCategory;
